import { render } from "./GrowthNavigation.vue?vue&type=template&id=54d348a7"
import script from "./GrowthNavigation.vue?vue&type=script&lang=js"
export * from "./GrowthNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__